// extracted by mini-css-extract-plugin
export default {"wrapper":"bTrN4PMmrlTB6H3qsayy","icon":"cEAC8yuVioqjMd24UQRg"};